export const hasPermission = (user, requiredPermissions = [], projectPermissions = null, scope = 'project') => {
    if (!user || !Array.isArray(requiredPermissions)) return false;

    const roles = user.llc_roles ?? [];
    if (Array.isArray(roles) && roles.some(role => role.slug.toLowerCase() === 'superadmin')) {
        return true;
    }

    const wpRoles = user.roles ?? [];
    if (Array.isArray(wpRoles) && wpRoles.includes('administrator')) {
        return true;
    }

    let userPermissions = [];
    if (scope === 'project' && projectPermissions) {
        userPermissions = Array.isArray(projectPermissions) ? projectPermissions : [];
    }
    if (scope === 'global') {
        userPermissions = user.llc_permissions ?? [];
    }

    if (!Array.isArray(userPermissions)) return false;

    return requiredPermissions.some(permission => userPermissions.includes(permission));
};
